"use client";

import { useSession } from "next-auth/react";
import { useEffect } from "react";
import userflow from "userflow.js";

import { config } from "@/config";
import { useMe } from "@/features/account/hooks/use-me";

export function RouteChangeListener() {
  const session = useSession();
  const { data: customer, isLoading } = useMe(session.data);

  useEffect(() => {
    if (config.NEXT_PUBLIC_USERFLOW_TOKEN) {
      userflow.init(config.NEXT_PUBLIC_USERFLOW_TOKEN);
    }
  }, []);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (customer?.id) {
      userflow.identify(customer.id, {
        name: [customer.firstName, customer.lastName].filter(Boolean).join(" "),
        email: customer.email,
      });
    } else {
      userflow.identifyAnonymous();
    }
  }, [customer, isLoading]);

  return null;
}
